import classNames from "classnames";
import { NavigationModel } from "models/NavigationModel";
import { useLayout } from "providers";

import { HeaderNavDropdown } from "./HeaderNavDropdown";

interface HeaderNavItemProps {
  className?: string;
  item: NavigationModel;
}

export const HeaderNavItem: React.FC<HeaderNavItemProps> = ({ className, item }) => {
  const { handleNavClick } = useLayout();

  const children = item.children;
  if (children) {
    return <HeaderNavDropdown item={item} children={children} />;
  }

  const { isSelected, iconStart, iconEnd, text } = item;
  const linkClass = classNames(className, isSelected ? "active" : "");

  return (
    <div className="sbb-header-nav-item">
      <a
        href="#"
        className={linkClass}
        onClick={(e) => {
          e.preventDefault();
          handleNavClick(item);
        }}
      >
        {iconStart ? <div className="sbb-header-nav-item-icon me-2">{iconStart}</div> : null}
        {text}
        {iconEnd ? <div className="sbb-header-nav-item-icon ms-2">{iconEnd}</div> : null}
      </a>
    </div>
  );
};
